var _defs, _polygon, _polygon2, _line, _path, _polygon3, _polygon4, _line2, _g, _g2, _circle, _circle2, _g3, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefinholycross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "215 45 260 305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st2 {\n        stroke: #B8860B;\n        stroke-width: 2px;\n      }\n\n      .st1 {\n        stroke: #8B0000;\n        stroke-width: 1.25px;\n      }\n\n      .st2 {\n        fill: #B8860B;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "457.05 181.24 421.13 160.5 342.37 181.24 421.13 201.98 457.05 181.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "227.69 181.24 263.61 201.98 342.37 181.24 263.61 160.5 227.69 181.24"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 227.69,
    y1: 181.24,
    x2: 457.05,
    y2: 181.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.83,337.49h-21.95l1.04-2.88,1.69-3.44v-54.43h14.15v53.77c0,1.22,1.64,2.43,1.64,3.65,0,2.18,3.43,1.15,3.43,3.33Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "342.37 295.92 363.11 260 342.37 181.24 321.63 260 342.37 295.92"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "342.37 66.55 321.63 102.48 342.37 181.23 363.11 102.48 342.37 66.55"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 66.55,
    x2: 342.37,
    y2: 295.92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 343.41,
    y1: 178.74,
    x2: 271.82,
    y2: 255.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 343.41,
    y1: 178.74,
    x2: 291.33,
    y2: 209.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 343.41,
    y1: 178.74,
    x2: 312.99,
    y2: 236.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.71,
    y1: 179.49,
    x2: 414.3,
    y2: 102.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.71,
    y1: 179.49,
    x2: 394.79,
    y2: 148.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.71,
    y1: 179.49,
    x2: 373.12,
    y2: 122.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.23,
    y1: 179.23,
    x2: 416.78,
    y2: 250.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.23,
    y1: 179.23,
    x2: 371.11,
    y2: 231.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.23,
    y1: 179.23,
    x2: 397.57,
    y2: 209.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.37,
    y1: 181.24,
    x2: 265.82,
    y2: 109.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.37,
    y1: 181.24,
    x2: 311.48,
    y2: 129.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.37,
    y1: 181.24,
    x2: 285.03,
    y2: 150.82
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 181.24,
    x2: 352.29,
    y2: 262.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 181.24,
    x2: 331.71,
    y2: 263.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.71,
    y1: 182.2,
    x2: 331.79,
    y2: 101.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.71,
    y1: 182.2,
    x2: 352.37,
    y2: 100.23
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.58,
    y1: 180.87,
    x2: 260.7,
    y2: 190.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.58,
    y1: 180.87,
    x2: 259.61,
    y2: 170.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 340.62,
    y1: 180.21,
    x2: 421.51,
    y2: 170.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 340.62,
    y1: 180.21,
    x2: 422.6,
    y2: 190.87
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 342.37,
    cy: 181.23,
    r: 21.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 342.37,
    cy: 181.23,
    r: 9.92
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 171.92,
    x2: 342.37,
    y2: 190.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 336.17,
    y1: 178.04,
    x2: 348.57,
    y2: 178.04
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.08,
    y1: 180.78,
    x2: 342.37,
    y2: 181.24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 181.68,
    x2: 342.7,
    y2: 182.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinholycross);
export default __webpack_public_path__ + "static/media/definholycross.d7b075e38fe9fa9ee2ff90aa78d0eb42.svg";
export { ForwardRef as ReactComponent };